import Breadcrumb from "../../Component/Breadcrumb";

function RecommendationParents() {
  return (
    <>
      <Breadcrumb>Policies / Recommendation to Parents</Breadcrumb>
      <div className="innersec">
        <div className="container">
          <div className="col-lg-12">
            <h1>Recommendations to the parents</h1>
          </div>
          <div className="recommendations-section">
            <div className="recommendations-card shadow-sm  rounded-4 bg-white">
              <ol className="modern-list">
                <li>
                  Parents are expected to co-operate with the school authorities
                  by ensuring that the children observe punctuality, regularity,
                  and discipline, prepare their lessons, and take an active part
                  in the activities of the school.
                </li>
                <li>
                  Private tuition is not encouraged. Instead, parents are
                  requested to give personal attention to their children and
                  help them with their doubts as far as possible.
                </li>
                <li>
                  Parents should check the student’s diary regularly and sign
                  any report recorded by teachers, along with assignments and
                  homework.
                </li>
                <li>
                  Parents/guardians are requested to stay in touch with the
                  school to know their ward's progress and must attend
                  Parent-Teacher meetings.
                </li>
                <li>
                  Parents are not allowed to interview teachers in classrooms or
                  the staff room. Those who wish to discuss academic matters
                  should do so during the Parent-Teacher meeting or through the
                  Principal.
                </li>
                <li>
                  Parents/guardians should not enter classrooms during school
                  hours or call students out. In case of necessity, please
                  contact the school office.
                </li>
                <li>
                  If a student is likely to be absent due to illness for a long
                  period, the Principal must be informed with a leave
                  application and a medical certificate within a week.
                </li>
                <li>
                  The Principal or teacher may punish a pupil for habitual
                  idleness, disobedience, misconduct, or indiscipline by
                  suspension or removal.
                </li>
                <li>
                  Criticism of teachers in the presence of students must be
                  avoided. For legitimate complaints, contact the Principal
                  directly.
                </li>
                <li>
                  Children must be trained in self-help — keeping their rooms
                  tidy, making their beds, polishing shoes, and carrying their
                  bags — fostering dignity of work and responsibility.
                </li>
                <li>
                  The school is not responsible for students’ safety after
                  school hours. Parents must make arrangements to take children
                  home immediately after class.
                </li>
                <li>
                  The school accepts no responsibility if, due to failure in
                  wearing uniform, bringing books, getting parental signatures,
                  or paying fees on time, the student is sent home during class
                  hours.
                </li>
                <li>
                  No school business will be transacted during holidays or after
                  hours.
                </li>
                <li>
                  The signatory on the admission form is responsible for the
                  student and must attend meetings or contact the school when
                  required. Guardians must be officially introduced to the
                  Principal to represent the parents.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default RecommendationParents;
